import importerActions from 'modules/shared/importer/importerActions';
import selectors from 'modules/eboxModuleCompartiment/importer/eboxModuleCompartimentImporterSelectors';
import EboxModuleCompartimentService from 'modules/eboxModuleCompartiment/eboxModuleCompartimentService';
import fields from 'modules/eboxModuleCompartiment/importer/eboxModuleCompartimentImporterFields';
import { i18n } from 'i18n';

export default importerActions(
  'CLUSTER_IMPORTER',
  selectors,
  EboxModuleCompartimentService.import,
  fields,
  i18n('entities.eboxModuleCompartiment.importer.fileName'),
);
